'use client';

import { FC, useActionState } from 'react';
import { Alert, Anchor, Button, Card, Flex, Text, TextInput } from '@mantine/core';
import { SlArrowRight } from 'react-icons/sl';
import { AppPaths } from '@/configs/appPaths';
import { RegistrationFormValues } from '@/app/register/actions';
import { handleResetPasswordForm } from '@/app/password-reset/actions';

interface Props {
}

const initialState = {
	error: '',
	message: '',
	values: {} as Partial<RegistrationFormValues>,
}

export const ClientPasswordResetForm : FC<Props> = () => {
	const [state, formAction, pending] = useActionState(handleResetPasswordForm, initialState)

  return (
		<Card component={'form'} action={formAction}>
			{state.message ? (
				<Alert
					color="green"
					mb="md"
					title="Sukces">
					{state.message}
				</Alert>
			) : (
				<>
					{state.error && (
						<Alert
							color="red"
							mb="md"
							title="Błąd">
							{state.error}
						</Alert>
					)}

					<TextInput
						required
						type="email"
						name="email"
						label="Adres email przypisany do konta"
						mb="md"
					/>
					<Button fullWidth mb="xl" type={'submit'} loading={pending}>
						<Flex gap="sm" align="center">
							<Text fw="bold">Przypomnij hasło</Text>
							<SlArrowRight size={20} />
						</Flex>
					</Button>
					<Text>
						<Anchor href={AppPaths.LOGIN} underline="always" mb="md">
							Kliknij tutaj
						</Anchor>{' '}
						aby wrócić do logowania
					</Text>
				</>
			)}
		</Card>
	)
}